<template>
  <div class="h5-header">
    <div
      class="h5-header-banner"
      :style="renderStyles()"
    >
      <div
        class="h5-header-top"
        v-if="isHome"
      >
        <div class="h5-header-top-title">
          Your Gateway to Unlimited Goods!
        </div>
        <div class="h5-header-top-desc">
          Discover millions of products for your needs.
        </div>
      </div>
      <div class="h5-header-main">
        <div class="h5-header-main-left">
          <div
            class="h5-header-menu"
            @click="showCategory"
          >
            <img
              src="@/assets/H5/home/h5-menu.svg"
              alt=""
            >
          </div>

          <div
            class="h5-header-main-logo"
            @click="goHome"
          >
            <img
              src="@/assets/H5/home/logo.svg"
              alt=""
            >
          </div>
        </div>
        <div class="h5-header-main-right">
          <div
            class="h5-header-sign"
            @click="signIn"
          >
            <img
              src="@/assets/H5/home/person.svg"
              alt=""
            >
          </div>
          <div
            class="h5-header-item h5-header-cart"
            @click="toCartPage"
          >
            <template v-if="userInfo.uid">
              <div
                v-if="cartCount"
                class="cart-count"
              >
                {{ cartCount > 99 ? '99+' : cartCount }}
              </div>
              <img
                v-if="cartCount === 0"
                src="@/assets/H5/carts/empty-cart.svg"
                alt=""
              >
              <img
                v-else
                src="@/assets/H5/carts/cart-icon.svg"
                alt=""
              >
            </template>
            <img
              v-else
              src="@/assets/H5/carts/empty-cart.svg"
              alt=""
            >
          </div>
          <div
            class="h5-header-item"
            @click="toOrderPage"
          >
            <img
              src="@/assets/images/order.svg"
              alt=""
            >
          </div>
          <div
            class="h5-header-country"
            @click="showCurrency"
          >
            <img
              :src="countryInfo[0]?.countryUrl"
              alt=""
              class="h5-country-logo"
            >
            <div>
              {{ countryInfo[0]?.countryCode }}
            </div>
            <img
              src="@/assets/H5/home/down.svg"
              alt=""
            >
          </div>
        </div>
      </div>
    </div>
    <div class="h5-home-header-search">
      <div
        class="language-selectbox"
        v-if="showLangunageSelectBox"
      >
        <div class="language-selectbox-selected">
          <div class="selected">
            <!-- English / EN -->
            {{ String(selectedLanguage).toLocaleUpperCase() }}
            <img
              src="@/assets/H5/home/arrow-down.svg"
              alt=""
            >
          </div>
        </div>
        <div class="language-selectbox-list">
          <div
            @click="chooseLanguage(item)"
            v-for="(item, index) in language.list"
            :key="index"
            class="language-selectbox-list-item"
          >
            {{ `${ item.sourceLan } / ${String(item.language).toLocaleUpperCase()}` }}
          </div>
        </div>
      </div>
      <div
        class="h5-header-search-container"
        @click="showSearchFoucs"
      >
        <div
          @click.stop="showLanguageSelect"
          class="search-container-language-selectbox-wrapper"
        >
          <div class="search-container-language-selectbox">
            {{ language.current.toLocaleUpperCase() }} <img
              src="@/assets/H5/home/arrow-down.svg"
              alt=""
            >
          </div>
        </div>
        <input
          class="search-container-text"
          placeholder="🔍 Search anything you want"
          type="text"
        >
        <div class="search-container-btn">
          <div
            @click.stop="photoClick"
            class="container-btn-photo"
          >
            <img
              src="@/assets/H5/home/photo.svg"
              alt=""
            >
          </div>
          <div
            class="container-btn-search"
            @click="searchText"
          >
            <img
              src="@/assets/H5/home/search.svg"
              alt=""
            >
          </div>
        </div>

        <!-- 图片搜索提示 -->
        <div
          :class="{
            'image-search-floating': true,
            'floating': showImageSearchFloating,
            'collapse': !showImageSearchFloating
          }"
        >
          <img
            src="@/assets/illus/illus-camera.svg"
            alt=""
          >
          Search By Image
          <div class="arrow" />
        </div>

        <!-- 图片搜索下拉框 -->
        <H5ImageSearchDropdown ref="imageSearchDropdownRef" />
      </div>
    </div>

    <H5Dialog
      v-model="showH5Currency"
      :height="`calc(${innerHeight}px - 80px)`"
      :init-styles="{ background: 'white' }"
    >
      <H5Currency :handle-click-outside="handleCurrencyClickOutside" />
    </H5Dialog>
    <H5FullMask @mask-click="showLangunageSelectBox = false" />
  </div>
</template>

<script setup>
import H5Dialog from '@/components/H5/H5Dialog/index.vue'
import H5Currency from '@/components/H5/H5Currency/index.vue'
import H5FullMask from '@/components/H5/H5FullMask/index.vue'
import { computed, onMounted, ref } from 'vue'
import { fetchData } from '../../../utils/fetch'
import { useStore } from 'vuex'
import { buriedPointUtil, gaAnalytics } from '@/utils/utils'
import { useRouter } from 'vue-router'
import { useLoginModal } from '@/components/Login'
import { useUserStore } from '@/pinia/user'
import H5ImageSearchDropdown from '@/components/H5/H5ImageSearchDropdown/index.vue'
import { useValidCache } from '@/hooks/useValidCache'
import storage from '@/utils/storage'
import { useLanguageStore } from '@/pinia/language'

const router = useRouter()
const user = useUserStore()
const { open: openLoginModal } = useLoginModal()
const language = useLanguageStore()

const showH5Currency = ref(false)

const store = useStore()
const innerHeight = ref(0)

const showImageSearchFloating = ref(true)
const imageSearchDropdownRef = ref(null)

const userInfo = computed(() => user.userInfo)
const countryInfo = computed(() => store.state.countryInfo)

const cartCount = computed(() => store.state.cart.cartCount)

const isHome = window.location.pathname === '/'

const searchText = (e) => {
  gaAnalytics('mp_search_click', 'mp_search_click')
}

const goHome = () => {
  window.location.href = '/'
}

const closeImageSearchDropdown = () => {
  imageSearchDropdownRef.value.hidden()
}

onMounted(async () => {
  innerHeight.value = window.innerHeight
  getCountry()
  getCurrencyList()

  setTimeout(() => {
    showImageSearchFloating.value = false
  }, 1100)

  window.addEventListener('click', closeImageSearchDropdown)
  window.addEventListener('scroll', closeImageSearchDropdown)
})

onUnmounted(() => {
  window.removeEventListener('click', closeImageSearchDropdown)
  window.removeEventListener('scroll', closeImageSearchDropdown)
})

const getCountry = async () => {
  const { cacheData, CACHE_VERSION } = useValidCache('cacheCountryList')
  if (cacheData.value) {
    store.commit('setCountryInfo', cacheData.value.data)

    const countryObj = localStorage.getItem('setCurrentCountry')
      ? JSON.parse(localStorage.getItem('setCurrentCountry'))
      : cacheData.value.data[0]
    store.commit('setCurrentCountry', countryObj)
    return
  }

  const { code, data } = await fetchData('/dsp-app/alibaba-common/country')
  if (code === 200) {
    const cacheData = {
      data,
      timestamp: Date.now(),
      cache_version: CACHE_VERSION
    }
    storage.set('cacheCountryList', JSON.stringify(cacheData))

    store.commit('setCountryInfo', data)

    const countryObj = localStorage.getItem('setCurrentCountry')
      ? JSON.parse(localStorage.getItem('setCurrentCountry'))
      : data[0]
    store.commit('setCurrentCountry', countryObj)
  }
}

const getCurrencyList = async () => {
  const { code, data } = await fetchData('/dsp-app/alibaba-common/currencyList')
  if (code === 200) {
    const _cache = storage.get('currencyData')
    let target
    if (_cache) {
      target = data.find((item) => item.targetCurrency === _cache.targetCurrency)
    } else {
      target = data[0]
    }
    storage.set('currencyData', target)
    store.commit('setCurrencyData', target)
    store.commit('setCurrencyList', data)
  }
}

const showSearchFoucs = () => {
  store.commit('h5Module/setSearchFoucs', true)
  store.commit('setEmptyObj', {})
}

const signIn = () => {
  if (userInfo.value.uid) {
    router.push('/account')
  } else {
    gaAnalytics('mp_sign_in_click', 'mp_sign_in_click')
    buriedPointUtil({ eventId: 'MPWH201' })
    buriedPointUtil({ eventId: 'MPLG501' })
    store.commit('setPassiveLogin', 0)
    openLoginModal()
  }
}

const showCurrency = () => {
  showH5Currency.value = true
}

const handleCurrencyClickOutside = () => {
  showH5Currency.value = false
}
const photoClick = () => {
  buriedPointUtil({ eventId: 'MPSC202' })
  imageSearchDropdownRef.value.show()
}

const renderStyles = () => {
  if (window.location.pathname.includes('/offer')) {
    return {
      background: 'none'
    }
  }
}

const showLangunageSelectBox = ref(false)
const showLanguageSelect = () => {
  showLangunageSelectBox.value = true
  store.commit('h5Module/setFullMask', true)
}

const showCategory = () => {
  store.commit('h5Module/setCategoryDialogVisible', true)
  buriedPointUtil({ eventId: 'MPWH401' })
}

const selectedLanguage = computed(() => {
  const item = language.list.find(item => item.language === language.current)
  return `${item.sourceLan} / ${item.language}`
})

const chooseLanguage = (item) => {
  language.update(item.language)
  showLangunageSelectBox.value = false
  store.commit('h5Module/setFullMask', false)
}

const toCartPage = () => {
  buriedPointUtil({ eventId: 'MPC201' })
  router.push('/carts')
}

const toOrderPage = () => {
  router.push('/orders')
}

</script>

<style lang="less">
@import "./index.less";
</style>
